import styled from 'styled-components';

const ElectricSpeedVariationWrapper = styled.div``;

export { ElectricSpeedVariationWrapper };
